import CurrentRegionSettings from 'constants/current-region-settings'


export default function shouldAutoGrant() {
  return CurrentRegionSettings.isOptOut() && !navigator.globalPrivacyControl
}
